export function phoneNumberInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9()+]/g, '');
}

export function alphaNumericForceUppercaseInputFilter(value: string): string {
    if (!value) return '';

    return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function abnInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9]/g, '').substr(0, 11);
}

export function prescriberNumberInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9]/g, '').substr(0, 7);
}

export function hpiOInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9]/g, '').substr(0, 16);
}

export function numberInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9]/g, '');
}

export function numberEqualToOneInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^1]/g, '');
}

export function numberGreaterThanZeroInputFilter(value: string): string {
    if (!value) return '';
    if (value === '0') return '';

    return value.replace(/[^0-9]/g, '');
}

export function decimalNumberInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9.]/g, '');
}

export function numberStringInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9\s]/g, '');
}

export function uppercaseStringInputFilter(value: string): string {
    if (!value) return '';

    return value.toUpperCase();
}

export function dateInputFilter(value: string): string {
    if (!value) return '';

    // expected value dd/MM/yyyy
    return value.replace(/[^0-9\/]/g, '').substr(0, 10);
}

export function timeInputFilter(value: string): string {
    if (!value) return '';

    // expected value HH:mm
    return value.replace(/[^0-9:]/g, '').substr(0, 5);
}

export function emailInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^0-9a-zA-Z\@\.]/g, '');
}

export function alphaNumericInputFilter(value: string): string {
    if (!value) return '';

    return value.replace(/[^a-zA-Z0-9\s,!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, '');
}
